import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { Password, Tenant, Juris, ProfileInfo } from '../../core/index.model'
import { SessionStorageService, PageContentService, PasswordService, ParameterConfigService } from '../../core/index.service'
import { UserRole, HttpStatus } from '../../core/enumtype';
import { Guid } from '../../core/guid';
import { EmailControl } from '../../shared/controls/email.control';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../citizen/index.service';
import { JurismgmtService } from '../../core/index.service';

@Component({
    selector: 'shared-resetpassword',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['./resetpassword.component.css']
})
export class ResetPasswordComponent implements OnInit {

    @Input() isAdmin: boolean = false;
    @Input() Email: string;
    @Input() TemporyPwd: string;
    @Output() onResetClick: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild(EmailControl) emailControl: EmailControl;

    public resetpasswordForm: FormGroup;
    public profile: ProfileInfo;
    objTenant: Tenant;
    public juris: Juris;
    message: string;
    isError: boolean = false;
    isAlert: boolean = false;
    isWarning: boolean;
    showLoading: boolean = false;
    jurisid: string;
    constructor(
        private _fb: FormBuilder,
        private route: ActivatedRoute,
        private passwordService: PasswordService,
        private storageService: SessionStorageService,
        private pagecontentService: PageContentService,
        public paramConfigService: ParameterConfigService,
        private profileService: ProfileService,
        private jurisService: JurismgmtService
    ) { }

    ngOnInit() {
        this.formGroup(); 
        if (this.isAdmin) {
           this.getadmininfo(this.route.snapshot.params['jurisid']);
        }
        else {
            this.getcitizeninfo(this.route.snapshot.params['citizenid']);
        }
        
    }
    getcitizeninfo(citizenID: string) {
        this.showLoading = true;

        this.profileService
            .editProfile(citizenID)
            .subscribe(
                data => {
                    // Success
                    if (data.status == HttpStatus.Success) {
                        this.profile = data.json()[0];
                        this.resetpasswordForm.controls.Email.setValue(this.profile.Email);

                        this.objTenant = this.storageService.getTenantState();

                        if (this.objTenant) {
                            let objJuris: Juris = this.objTenant.Juris.find(row => row.JurisNo === this.profile.JurisID);
                            this.storageService.setJurisDetails(objJuris)
                            this.paramConfigService.LoadSystemParams(this.storageService.getJurisNo());
                        }
                    }
                    else {

                    }
                },
                error => {
                    // Error
                    this.showAlert(error.message, true);
                    this.showLoading = false;
                },
                () => { this.showLoading = false; }
            );
    }
    getadmininfo(jurisID: string) {
        this.showLoading = true;

        this.jurisService
            .getJurisById(jurisID)
            .then(
                data => {
                    // Success
                    if (data) {
                        this.juris = data;
                        this.resetpasswordForm.controls.Email.setValue(this.juris.EmailID);

                        this.objTenant = this.storageService.getTenantState();

                        if (this.objTenant) {
                            let objJuris: Juris = this.objTenant.Juris.find(row => row.JurisNo === this.juris.JurisNo);
                            this.storageService.setJurisDetails(objJuris)
                            this.paramConfigService.LoadSystemParams(this.storageService.getJurisNo());
                        }
                    }
                    this.showLoading = false;
                },
                error => {
                    // Error
                    this.showAlert(error.message, true);
                    this.showLoading = false;
                },
               
            );
    }
    // From Control Group

    formGroup() {

        this.resetpasswordForm = this._fb.group({
            TempPwdID: null,
            JurisID: null,
            UserID: null,
            UserRole: null,
            Email: this.storageService.getUserEmail(),
            IPAddress: null,
            IsActive: 0,
            TempPwd: null,
            Pwd: null,
            ConfirmNewPassword: null
        });
    }

    cmdSubmit(model: Password, isValid: boolean) {

        model.TempPwdID = Guid.newGuid();
        model.UserID = Guid.emptyGuid();

        if (this.isAdmin) {
            model.UserRole = UserRole.Admin.toString();
            model.IsAdmin = 1;
        }
        else {
            model.UserRole = UserRole.Citizen.toString();
            model.IsAdmin = 0;
        }

        model.JurisID = this.storageService.getJurisNo();

        if (isValid) {
            if (model.Pwd === model.ConfirmNewPassword) {

                this.showLoading = true;

                this.passwordService.resetPassword(model).subscribe(res => {
                    if (res.status == HttpStatus.Success && res.json()) {
                        this.clearFields();
                        this.showAlert(this.pagecontentService.getKeyTxt('Msg_Pwd_Chng', this.storageService.getLang()), false);
                    }
                    else {
                        this.showAlert(this.pagecontentService.getKeyTxt('Msg_Invalid_TempPwd', this.storageService.getLang()), true, true);
                    }
                    this.showLoading = false;
                }, error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
            }
            else {
                this.showAlert(this.pagecontentService.getKeyTxt('Msg_PwdMissMatch', this.storageService.getLang()), true, true);
            }
            

        }
        else {
            if (this.emailControl.value && !this.emailControl.isValidEmail)
                this.showAlert(this.pagecontentService.getKeyTxt('Msg_InvalidEmail', this.storageService.getLang()), true, true);
            else
                this.showAlert(this.pagecontentService.getKeyTxt('Msg_Mandatory', this.storageService.getLang()), true, true);
        }
    }
    clearFields() {
        this.resetpasswordForm.controls.Email.setValue('');
        this.resetpasswordForm.controls.TempPwd.setValue('');
        this.resetpasswordForm.controls.Pwd.setValue('');
        this.resetpasswordForm.controls.ConfirmNewPassword.setValue('');
    }
    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/login/resetpassword.component.ts